<template>

        <div class="flex align-items-center justify-content-center">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
            <span>Are you sure you want to reject this candidate ?</span>
        </div>

</template>
<script>

</script>
